export interface FormlySummary {
  key: string;
  label: string;
}
